import { render, staticRenderFns } from "./DialogAddHistory.vue?vue&type=template&id=bb11c222&scoped=true"
import script from "./DialogAddHistory.vue?vue&type=script&lang=js"
export * from "./DialogAddHistory.vue?vue&type=script&lang=js"
import style0 from "./DialogAddHistory.vue?vue&type=style&index=0&id=bb11c222&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb11c222",
  null
  
)

export default component.exports